<script lang="ts" setup>
import { watch } from "vue";
import { useI18n } from "vue-i18n";

import { Dialog, DialogOverlay, DialogPanel, DialogTitle } from "../../../components/ui/dialog";
import { DialogDescription } from "@headlessui/vue";

import TestGrantForm from "./TestGrantForm.vue";

const { t } = useI18n();

const props = defineProps<{
  show: boolean;
  knocId: string | null;
}>();

const emit = defineEmits<{
  (e: "update:show", value: boolean): void;
  (e: "success", message: string): void;
  (e: "error", message: string): void;
}>();

// If you still want to reset form state on open/close you can handle that
watch(
  () => props.show,
  (newValue) => {
    if (!newValue) {
      // nothing needed here now – the form resets itself on success
    }
  },
);

function handleClose() {
  emit("update:show", false);
}

function handleSuccess(message: string) {
  emit("success", message);
  emit("update:show", false);
}

function handleError(message: string) {
  emit("error", message);
}
</script>

<template>
  <Dialog :show="show">
    <DialogOverlay v-if="show" />

    <DialogPanel class="max-w-[600px]">
      <DialogTitle>{{ t("pages.knocs.dialogs.testGrant.heading") }}</DialogTitle>

      <DialogDescription>
        {{ t("pages.knocs.dialogs.testGrant.description") }}
      </DialogDescription>

      <div class="mt-4">
        <TestGrantForm
          :knoc-id="knocId"
          :show-cancel="true"
          @close="handleClose"
          @error="handleError"
          @success="handleSuccess"
        />
      </div>
    </DialogPanel>
  </Dialog>
</template>
